import React from 'react'
import { FormField } from '../../../../Common/FormField'
import { NameFormErrors } from '../../FullName/types'
import styles from './BasicInformation.module.css'

interface NameFormFieldProps {
    fieldName: string
    fieldValue: string
    setFieldValue: (_value: string) => void
    label: string
    placeholder: string
    disabled?: boolean
    nameErrors: NameFormErrors
    onBlur: (_fieldName: string) => void
}

export const NameFormField = ({
    fieldName,
    fieldValue,
    setFieldValue,
    label,
    placeholder,
    disabled = false,
    nameErrors,
    onBlur,
}: NameFormFieldProps) => (
    <div>
        <FormField
            label={label}
            placeholder={placeholder}
            value={fieldValue}
            onChange={setFieldValue}
            onBlur={() => onBlur(fieldName)}
            disabled={disabled}
        />
        {nameErrors[fieldName] && (
            <p className={styles.errorMessages}>{nameErrors[fieldName]}</p>
        )}
    </div>
)

